// extracted by mini-css-extract-plugin
export default {"container":"Perpetrator_container__TCxrT","page":"Perpetrator_page__0OEfu","section":"Perpetrator_section__fqgBC"};